import React from 'react'
import './legends.scss'

interface ILegends {
  label: string
  icon: React.ReactElement
}
export const Legends = ({ label, icon }: ILegends) => {
  return (
    <section className="legends">
      {icon}
      <p className="body-xs">{label}</p>
    </section>
  )
}

export default Legends
